export { default as appointments } from './appointment.svg';
export { default as home } from './home.svg';
export { default as meet } from './meet.svg'; 
export { default as patient } from './patient.svg';
export { default as payment } from './payment.svg';
export { default as treat } from './treat.svg'; 

export { default as appointmentWhite } from './appointment-white.svg';
export { default as homeWhite } from './home-white.svg';
export { default as meetWhite } from './meet-white.svg'; 
export { default as patientWhite } from './patient-white.svg';
export { default as paymentWhite } from './payment-white.svg';
export { default as treatWhite } from './treat-white.svg';



